import { fetchContentApi } from '@app/store/fetch-saga';
import { getOrganizationId } from '@app/store/selectors';
import { put, select } from '@app/store/typed-saga-effects';
import { logger } from '@app/utilities/logger';
import { toast } from 'react-hot-toast';

import type { RecordingEvent } from './event';

export function* deleteEdit(
  action: Extract<
    RecordingEvent,
    { type: '[advanced-editor] delete edit requested' }
  >,
) {
  const { editId, recordingId } = action.payload;
  const organizationExternalId = yield* select(getOrganizationId);

  if (!organizationExternalId) return;

  try {
    yield* fetchContentApi(
      `/v2/${organizationExternalId}/recordings/${recordingId}/edits/${editId}`,
      'DELETE',
      undefined,
      undefined,
      'text',
    );

    yield* put({
      type: '[advanced-editor] delete edit success',
      payload: { editId },
    });

    toast.success('content-recording.editor-v2.delete-edit-success');
  } catch (error: any) {
    const statusCode: number | undefined = error?.status ?? error?.statusCode;
    const reason =
      statusCode === 409
        ? ('processing_conflict' as const)
        : ('generic' as const);

    logger.error('[advanced-editor] delete edit failed', {
      editId,
      recordingId,
      organizationExternalId,
      reason,
      error,
    });

    yield* put({
      type: '[advanced-editor] delete edit failed',
      payload: { editId, reason },
    });

    if (reason === 'processing_conflict') {
      toast.error('content-recording.editor-v2.delete-edit-failed-processing');
    } else {
      toast.error('content-recording.editor-v2.delete-edit-failed');
    }
  }
}
